var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarPlaceHolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.8119 5.25C5.8119 3.56726 7.17604 2.20312 8.85878 2.20312C10.5415 2.20312 11.9057 3.56726 11.9057 5.25C11.9057 6.93274 10.5415 8.29688 8.85878 8.29688C7.17604 8.29688 5.8119 6.93274 5.8119 5.25Z",
    fill: "#5F6168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99296 9.16406C10.9939 9.16406 12.9346 10.4237 13.8584 12.8082C14.1806 13.6401 13.9651 14.4532 13.4674 15.0348C12.9791 15.6052 12.219 15.9609 11.4002 15.9609H6.58572C5.76695 15.9609 5.00677 15.6052 4.51855 15.0348C4.02083 14.4532 3.80529 13.6401 4.12756 12.8082C5.05136 10.4237 6.99205 9.16406 8.99296 9.16406Z",
    fill: "#5F6168"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarPlaceHolder);
export default __webpack_public_path__ + "static/media/avatar-place-holder.6ce2badbbb86a4a4553f5c49f66a0d85.svg";
export { ForwardRef as ReactComponent };